import { z } from 'zod';

const envSchema = z.object({
  /** Base des appels XHR. Relative en production : même origine, pas de CORS. */
  VITE_API_URL: z.string().min(1).default('/api'),

  /**
   * Origine **absolue** de l'API, pour le seul flux OAuth.
   *
   * Le passage par Google est une navigation pleine page qui quitte le site et
   * y revient. Le cookie de `state` doit être posé et relu sur le **même
   * hôte**, sinon le navigateur ne le renvoie pas et le retour échoue en
   * `state_invalide`. Passer par `/api` ne marche pas : le cookie serait posé
   * sur `app.fidalia.fr` et relu sur `api.fidalia.fr`.
   */
  VITE_API_ORIGIN: z.url().default('http://localhost:3000'),

  /**
   * Fiche de l'extension navigateur sur le Chrome Web Store.
   *
   * En variable d'environnement parce que l'URL définitive dépend de
   * l'identifiant attribué à la publication : il n'existe pas encore, et le
   * jour où il existera, rien du code n'a à changer. Par défaut, la racine de
   * la boutique — un lien inutile mais jamais mort.
   */
  VITE_EXTENSION_URL: z
    .url()
    .default(
      'https://chromewebstore.google.com/detail/fidalia/jobhibbcpcmkehhidlmdiikiilhpdedl?hl=fr',
    ),

  /**
   * Mesure d'audience PostHog (région UE). La clé de projet est publique par
   * conception : elle ne donne qu'un droit d'écriture d'événements. Le suivi
   * ne tourne qu'en production, jamais en dev ni en test.
   */
  VITE_POSTHOG_KEY: z.string().default('phc_qsywrXq2uC7oXhbibX5RpxF8Z7hU2Xk5NZyGe7gvo9a4'),
  VITE_POSTHOG_HOST: z.url().default('https://eu.i.posthog.com'),
});

/** Variables d'env validées au démarrage : échec bruyant plutôt que 404 silencieux. */
export const env = envSchema.parse(import.meta.env);
